import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import { Question } from '../../types';

interface QuestionPresentationProps {
  question: Question;
}

export const QuestionPresentation: React.FC<QuestionPresentationProps> = ({ question }) => {
  return (
    <div>
      {/* Question Statement */}
      <div className="mt-4 prose prose-zinc dark:prose-invert max-w-none text-sm text-zinc-800 dark:text-zinc-200 leading-relaxed">
        <ReactMarkdown remarkPlugins={[remarkMath]} rehypePlugins={[rehypeKatex]}>
          {question.statement}
        </ReactMarkdown>
      </div>

      {/* Question Diagram with background transparency */}
      {question.imageUrl && (
        <div className="my-5 rounded border border-paper-200 bg-paper-50 p-2 dark:border-study-line dark:bg-study-card flex justify-center">
          <img
            src={question.imageUrl}
            alt="Diagrama da questão"
            className="max-h-72 object-contain filter dark:invert dark:contrast-125 transition-all duration-200"
          />
        </div>
      )}

      {/* Alternatives preview (read-only for context) */}
      <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-2 text-xs font-sans">
        {question.alternatives.map((alt) => (
          <div
            key={alt.id}
            className="flex items-center gap-2 rounded border border-paper-200 bg-paper-50 px-3 py-1.5 text-zinc-700 dark:border-study-line dark:bg-study-card dark:text-zinc-300"
          >
            <span className="font-mono font-bold uppercase text-zinc-400">{alt.id})</span>
            <span>{alt.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
